import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { SERVICE_RIDER_QUERY } from '../../../graphql.js'
import { Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { getData } from '../CustomUtils.js'

const SERVICE_RIDER = gql(SERVICE_RIDER_QUERY)

export default function ServiceRider({ location }) {
  console.log('ServiceRider rendered: ', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const caseId = params.get('caseId')
    getData(null, SERVICE_RIDER, 'serviceRider', setResults, setGraphQLErrors, 'caseId', caseId)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    return (
      <div className="custom-scroll">
        <div dangerouslySetInnerHTML={{ __html: results }} className="bordered-table" />
      </div>
    )
  }
}
